import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { SafeArea } from '../plugins/safe-area';
import { SafeAreaInfo } from '../interfaces/safe-area-info';

@Injectable({
  providedIn: 'root',
})
export class SafeAreaService {
  constructor() {}

  initialize() {
    if (Capacitor.getPlatform() === 'android') {
      SafeArea.getSafeArea().then((info: SafeAreaInfo) => {
        this.applySafeAreaStyles(info);
      });

      SafeArea.addListener('safeAreaDidChange', (info: SafeAreaInfo) => {
        this.applySafeAreaStyles(info);
      });
    }
  }

  applySafeAreaStyles(info: SafeAreaInfo) {
    const style = document.documentElement.style;
    style.setProperty('--ion-safe-area-top', `${info.top}px`);
    style.setProperty('--ion-safe-area-right', `${info.right}px`);
    style.setProperty('--ion-safe-area-bottom', `${info.bottom}px`);
    style.setProperty('--ion-safe-area-left', `${info.left}px`);
  }
}
